import React from 'react';

const HomePage = () => <h2 className="text-center">Welcome to StarDB</h2>;

export default HomePage;
